export function getAllInfo(axiosPrivate) {
  return axiosPrivate.get('/dashboard/info')
}

export function getAllInfoV2(axiosPrivate) {
  return axiosPrivate.get('/dashboard/v2/info')
}
